module.exports = __webpack_public_path__ + "media/images/emails-and-contacts-triplet-3-bcc279cf7cd1b6a6da56b0fa3a6e2d49.svg";